<template>
    <div>
        <BreadCrumb></BreadCrumb>
        <h2>Modul-Vorlage erstellen</h2>
        <div class="input-row" style="margin-bottom: 4px">
            <inputFloatLabel style="width: 50%;margin-right: 4px" label="Vorlagenname" @input="moduleNameChanged"
                             :value="moduleName"></inputFloatLabel>
            <inputFloatLabel style="width: 50%;" label="Technischer Name" @input="technicalNameChanged"
                             :value="technicalName"></inputFloatLabel>
        </div>
        <!--        <div class="medium-row" style="margin-bottom: 4px">
                    <InputFloatLabel style="width: 200px"
                                     class="setupInfos" icon-size="2.4em" :value="this.deviceType" label="Mediumbezeichnung"
                                     :icon="this.deviceMapping[this.deviceType]['icon']" iconColor="#D70465"
                                     @click="this.toggleDevice"
                                     @input="deviceInput">
                    </InputFloatLabel>
                </div>-->
        <div class="item-row">
            <div class="add-buttons">
                <AdaButton title="INTERACTION HINZUFÜGEN" @click="openAddInteractionsDialog" type="createButton"
                           icon="icon-add"></AdaButton>
            </div>
        </div>
        <AdaDatatable style="margin-bottom: 20px" :columns="columns" :data="interactions"
                      :show-pagination="false"
                      :show-search="false" :movable="true"
                      :size-of-page="100"
                      @moveUp="moveUp"
                      @moveDown="moveDown"
                      @rowClicked="cellClicked"
                      :transformers="transformers">
        </AdaDatatable>
        <AdaButton icon="icon-add" @click="openAddInteractionsDialog" type="fullWidthButton"
                   title="TRACKING HINZUFÜGEN"></AdaButton>
        <div style="margin-top: 20px">
            <AdaButton :loading="savingTemplate" style="width: 300px; height: 40px" title="MODUL SPEICHERN"
                       @click="createClicked"
                       type="createButton"></AdaButton>
        </div>
        <Dialog v-if="showAddInteractionsDialog" :show-close-button="true" :show="showAddInteractionsDialog"
                :has-backdrop="true" width="80%" max-width="1200px"
                @close="closeAddInteractionsDialog">
            <SelectInteractionsFromTable :initial-interactions="interactions"
                                         @selected="interactionsSelected"></SelectInteractionsFromTable>
        </Dialog>
    </div>
</template>

<script>

    import BreadCrumb from "../../../components/breadCrumb/BreadCrumb";
    import AdaDatatable from "../../../components/tables/AdaDatatable";
    import InputFloatLabel from "../../../components/inputs/InputFloatLabel";
    import {RepositoryFactory} from "../../../scripts/RepositoryFactory";
    import AdaButton from "../../../components/buttons/AdaButton";
    import Dialog from "../../../components/dialog/Dialog";
    import SelectInteractionsFromTable from "./SelectInteractionsFromTable";
    import Transformers from "../../../components/tables/Transformers";

    const InteractionsRepository = RepositoryFactory.get('interactions');
    const ModulesRepository = RepositoryFactory.get('modules');

    export default {
        components: {
            SelectInteractionsFromTable,
            BreadCrumb,
            AdaDatatable,
            InputFloatLabel,
            AdaButton,
            Dialog
        },
        data: function () {
            return {
                showAddInteractionsDialog: false,
                moduleName: '',
                technicalName: '',
                columns: [
                    {
                        viewName: 'Interaction Name',
                        propName: 'name',
                        sortable: true,
                        width: '25%'
                    },
                    {
                        viewName: 'Technischer Name',
                        propName: 'technical_name',
                        sortable: true,
                        width: '25%'
                    },
                    {
                        viewName: 'Aktion',
                        propName: 'action',
                        width: '10%'
                    },
                    {
                        viewName: 'Beschreibung',
                        propName: 'description',
                        width: '40%'
                    }
                ],
                interactions: [],
                transformers: [
                    {
                        propName: 'medium',
                        transform: Transformers.spaceModuleMediumTransformer
                    },
                    {
                        propName: 'action',
                        transform: Transformers.actionTransformer
                    }
                ],
                savingTemplate: false,
                fn: null
            }
        },
        name: "CreateModuleTemplate",
        mounted() {
            this.fn = () => {
                this.createClicked(true);
            };
            this.$root.$on('saveModuleTemplate', this.fn);
        },
        beforeDestroy() {
            this.$root.$off('saveModuleTemplate', this.fn);
        },
        watch: {
            technicalName: function (newVal, oldVal) {
                this.changeInteractionsTechnicalName(oldVal, newVal);
            }
        },
        methods: {
            arrayMove(array, from, to) {
                array.splice(to, 0, array.splice(from, 1)[0]);
            },
            moveUp(index) {
                if (index > 0) {
                    this.arrayMove(this.interactions, index, index - 1);
                }
            },
            moveDown(index) {
                if (index < this.interactions.length - 1) {
                    this.arrayMove(this.interactions, index, index + 1);
                }
            },
            createClicked(clickedFromHeader) {
                clickedFromHeader ? this.$root.$emit('trackinglistLoader', true) : this.savingTemplate = true;
                this.createModule(clickedFromHeader);
            },
            async createModule(clickedFromHeader) {
                try {
                    const interactionIds = this.interactions.map(inter => inter.id);
                    const json = {
                        name: this.moduleName,
                        technical_name: this.technicalName,
                        interactionIds: interactionIds,
                        is_template: 1
                    };
                    await ModulesRepository.createModule(json);
                    this.$noty.success("Die Modulvorlage wurde erfolgreich erstellt!");
                    this.$router.push({name: 'templatemodules'});
                } catch (e) {
                    console.error(e);
                    this.$noty.error("Fehler bei der Erstellung der Modulvorlage: " + e.message);
                }
                clickedFromHeader ? this.$root.$emit('trackinglistLoader', false) : this.savingTemplate = false;
            },
            interactionsSelected(selectedInteractions) {
                selectedInteractions.forEach(inter => {
                    inter.action = ['delete'];
                    if (inter.technical_name[0] !== '_') {
                        inter.technical_name = '_' + inter.technical_name;
                    }
                    inter.technical_name = this.technicalName + inter.technical_name;
                });
                this.interactions = selectedInteractions;
                this.showAddInteractionsDialog = false;
            },
            async fetchInteractions() {
                const {data} = await InteractionsRepository.getInteractionTemplates();
                data.forEach(int => {
                    int.actions = [];
                })
            },
            cellClicked: function (data) {
                let dataType = data.target.getAttribute('data-type');
                switch (dataType) {
                    case 'edit':
                        this.$router.push({name: 'editModule', params: {id: data.row.id}});
                        break;
                    case 'duplicate':
                        this.copyClicked(data.row);
                        break;
                    case 'delete':
                        this.interactions.splice(this.interactions.indexOf(data.row), 1);
                }
            },
            moduleNameChanged(val) {
                this.moduleName = val;
            },
            technicalNameChanged(val) {
                this.technicalName = val;
            },
            changeInteractionsTechnicalName(oldTechName, newTechName) {
                this.interactions.forEach(inter => {
                    if (oldTechName !== '') {
                        inter.technical_name = inter.technical_name.replace(oldTechName, '');
                    }
                    inter.technical_name = newTechName + inter.technical_name;
                })
            },
            openAddInteractionsDialog() {
                this.showAddInteractionsDialog = true;
            },
            closeAddInteractionsDialog() {
                this.showAddInteractionsDialog = false;
            }
        }
    }
</script>

<style lang="scss" scoped>

    .move {
        position: absolute;
        top: 0;
        left: 10px;
        display: flex;
        flex-flow: column;
        height: 36px;
        justify-content: space-between;
        font-size: 12px;
        color: $grey;
        padding: 4px 3px 1px 3px;
        margin-top: 2px;
        cursor: pointer;
    }

    .item-row {
        display: flex;
        flex-direction: row;
        margin-top: 10px;
        margin-bottom: 10px;
        background-color: white;
        padding: 10px;
        justify-content: flex-end;
    }

    .input-row {
        display: flex;
        flex-direction: row;
        justify-content: space-evenly;
    }

    .medium-row {
        background-color: white;
        padding: 10px;
    }

    ::v-deep .ada-table-container tr {
        display: flex;
    }

    ::v-deep .ada-table-container td {
        display: block;
    }

</style>